import React, { useContext } from 'react';
import { GlobalContext } from '../../common/GlobalContext';
import { OptionListColumnDimensions } from './FieldEditor';
import { token } from '@atlaskit/tokens';

export const FieldEditorOptionListHeader = ({ hasChildOptions, columnDimensions }: { hasChildOptions: boolean; columnDimensions: OptionListColumnDimensions }) => {
  const { t } = useContext(GlobalContext);

  const listHeaderStyle: any = {
    color: token('color.text.subtle', '#5E6C84'),
    fontSize: 12,
    fontWeight: 500,
  };
  return (
    <div style={{ display: 'flex', marginBottom: 8 }}>
      <div
        style={{
          width: columnDimensions.positionPx,
          maxWidth: columnDimensions.positionPx,
          minWidth: columnDimensions.positionPx,
          ...listHeaderStyle,
        }}
      >
        <div style={{ paddingLeft: columnDimensions.positionPaddingLeftPx }}>&#x2116;</div>
      </div>
      <div style={{ width: columnDimensions.activePx, maxWidth: columnDimensions.activePx, minWidth: columnDimensions.activePx, ...listHeaderStyle }}>{t('fieldEditor.table.disabled')}</div>
      <div style={{ flex: 1, ...listHeaderStyle }}>{t('fieldEditor.table.optionvalue')}</div>
      <div
        style={{
          width: columnDimensions.defaultPx,
          maxWidth: columnDimensions.defaultPx,
          minWidth: columnDimensions.defaultPx,
          ...listHeaderStyle,
        }}
      >
        {t('fieldEditor.table.default')}
      </div>
      {hasChildOptions && (
        <div style={{ width: columnDimensions.childPx, maxWidth: columnDimensions.childPx, minWidth: columnDimensions.childPx, ...listHeaderStyle }}>{t('fieldEditor.table.childoptions')}</div>
      )}
      <div style={{ width: columnDimensions.deletePx, maxWidth: columnDimensions.deletePx, minWidth: columnDimensions.deletePx, ...listHeaderStyle }}>&nbsp;</div>
    </div>
  );
};
